import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { authGuarForLogin, authGuard } from './auth.guard';
import { CloseConuterComponent } from './close-conuter/close-conuter.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
    canActivate: [authGuarForLogin],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'today-orders',
        loadComponent: () =>
          import('./today-orders/today-orders.component').then(
            (m) => m.TodayOrdersComponent
          ),
      },
      {
        path: 'kitchen-status',
        loadComponent: () =>
          import('./kitchen/kitchen.component').then((m) => m.KitchenComponent),
      },
      {
        path: 'order-history',
        loadComponent: () =>
          import('./order-history/order-history.component').then(
            (m) => m.OrderHistoryComponent
          ),
      },
      {
        path: 'rider',
        loadComponent: () =>
          import('./rider/rider.component').then((m) => m.RiderComponent),
      },
      {
        path: 'rider/map/:orderId',
        loadComponent: () =>
          import('./rider/map-page/map-page.component').then((m) => m.MapPageComponent),
      },
      {
        path: 'menu-consumed-invoice',
        loadComponent: () =>
          import(
            './invoices/menu-consumed-invoice/menu-consumed-invoice.component'
          ).then((m) => m.MenuConsumedInvoiceComponent),  
      },
      {
        path: 'stats',
        loadComponent: () =>
          import('./stats/stats.component').then((m) => m.StatsComponent),
      },
      {
        path: 'separate-kitchen',
        loadComponent: () =>
          import('./separate-order/separate-order.component').then(
            (m) => m.SeparateOrderComponent
          ),
      },
      {
        path: 'layout-settings',
        loadComponent: () =>
          import('./layout-settings/layout-settings.component').then(
            (m) => m.LayoutSettingsComponent
          ),
      },
      {
        path: 'expense',
        loadComponent:() =>import('./expense/expense.component').then((m) => m.ExpenseComponent),
      },
       {
        path: 'shift-reports',
        loadComponent:() =>import('./shift-report/shift-report.component').then((m) => m.ShiftReportComponent),
      },
      {
        path: 'close-shift',
        loadComponent:() =>import('./close-conuter/close-conuter.component').then((m) => m.CloseConuterComponent),
      },
      {
        path: 'call-center',
        loadComponent:() =>import('./call-center/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'call-center/rider-dashboard',
        loadComponent:() =>import('./call-center/rider-dashboard/rider-dashboard.component').then((m) => m.RiderDashboardComponent),
      },
      {
        path: 'call-center/assign-rider/:orderId',
        loadComponent: () => import('./call-center/assign-rider/assign-rider.component').then((m) => m.AssignRiderComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];
